import React, { useState } from 'react';
import DailyReconciliationTable from './components/DailyReconciliationTable';
import SubHeader from './components/SubHeader';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';
import {
  Content,
  Container,
} from 'components/BookingMain/styles';

const DailyReconciliationReport = () => {

  const [checkInDate, setCheckInDate] = useState(moment().tz(TIME_ZONE));
  const [checkOutDate, setCheckOutDate] = useState(moment().tz(TIME_ZONE).add(1, 'days'));
  const [dataTypes, setDataTypes] = useState([])
  const [reports, setReports] = useState([])

  return (
    <>
      <SubHeader
        checkInDate={checkInDate}
        setCheckInDate={setCheckInDate}
        checkOutDate={checkOutDate}
        setCheckOutDate={setCheckOutDate}
        dataTypes={dataTypes}
        setDataTypes={setDataTypes}
        setReports={setReports}
      />
      <Container>
        <DailyReconciliationTable
          reports={reports}
        />
      </Container>
    </>
  );
};

export default DailyReconciliationReport;
